/* eslint-disable check-file/filename-blocklist -- pre-existing .jsx; this change only adjusts the loader's position/phase, converting to .tsx is a separate migration */
import { useState } from 'react';
import { Box, Flex, Icon, usePrefersReducedMotion } from '@chakra-ui/react';
import { keyframes } from '@emotion/react';

import Logo from '@/assets/icons/Logo';

const SPIN_MS = 1000;
const spin = keyframes`from { transform: rotate(0deg); } to { transform: rotate(360deg); }`;

// Starts the spin at the same point of the turn every instance would be at by
// now, so when one loader replaces another (boot → route loading) the ring
// carries on instead of snapping back to 0° — the swap reads as one spinner.
const spinPhaseDelay = () => `-${Math.round(performance.now() % SPIN_MS)}ms`;

export const Loader = () => {
  const prefersReducedMotion = usePrefersReducedMotion();
  const [animationDelay] = useState(spinPhaseDelay);
  const animation = prefersReducedMotion
    ? undefined
    : `${spin} infinite ${SPIN_MS}ms ease`;
  return (
    <Box width="70px" height="70px" pos="relative">
      <Flex
        pos="absolute"
        top={0}
        left={0}
        alignItems="center"
        justifyContent="center"
        width="60px"
        height="60px"
        background="white"
        borderRadius="50%"
        borderTop="2px solid #3828AB"
        borderRight="2px solid #3828AB"
        borderBottom="2px solid #3828AB"
        borderLeft="2px solid transparent"
        animation={animation}
        sx={{ animationDelay }}
      />
      <Flex
        pos="absolute"
        top="5px"
        left="5px"
        bg="radial-gradient(50% 50% at 50% 50%, #608EFF 0%, rgba(78, 129, 255, 0) 100%)"
        alignItems="center"
        justifyContent="center"
        width="50px"
        height="50px"
        borderRadius="50%"
      >
        <Icon as={Logo} width="36px" height="36px" />
      </Flex>
    </Box>
    // <video
    //   autoPlay={true}
    //   muted
    //   loop
    //   style={{ width: '60px', pointerEvents: 'none' }}
    // >
    //   <source src="/static/loader.webm" type="video/webm" />
    //   {/* For unsupported browsers */}
    //   Loading...
    // </video>
  );
};
